import portrait from "../portrait-new.jpg";
import { HashLink } from "react-router-hash-link";

function Home() {
  return (
    <main className="hero">
      <div className="hero-copy">
        <p className="eyebrow">Research Platform Engineer · New York</p>
        <h1>Curious by nature.<br/><em>Serious about building.</em></h1>
        <p className="hero-intro">
          I’m Edward Xing, a Research Platform Engineer at Citadel Securities. I turn
          quantitative ideas into dependable platforms—combining a researcher’s
          curiosity with an engineer’s focus on scale, clarity, and reliability.
        </p>
        <div className="hero-actions">
          <HashLink className="button button-primary" smooth to="#projects">
            Selected work <span aria-hidden="true">↘</span>
          </HashLink>
          <a className="text-link" href="https://www.linkedin.com/in/edward-xing/" target="_blank" rel="noreferrer">
            LinkedIn <span aria-hidden="true">↗</span>
          </a>
        </div>
      </div>
      <div className="portrait-wrap">
        <div className="portrait-frame">
          <img src={portrait} alt="Edward Xing" />
          <span className="portrait-location">Hudson Yards · 2024</span>
        </div>
        <p className="portrait-caption">Engineer, maker, and persistent solver of puzzles.</p>
      </div>
      <div className="scroll-note" aria-hidden="true"><span>Scroll to explore</span><span className="scroll-line" /></div>
    </main>
  );
}

export default Home;
